var Dlrt;
(function (Dlrt) {
    class SingleDatePicker {
        constructor(input, options) {
            this.input = input;
            this.clearButton = this.input.siblings('.date-range-picker-clear');
            this.options = options;
            this.locale = Dlrt.Environment.Locale == 'fr' ? SingleDatePicker.LocaleFr : SingleDatePicker.LocaleEn;
            this.init();
        }
        init() {
            // initial date range confuses the hell out of the date range picker
            // => empty the input during initialization and restore initial dates afterwards
            this.input.val('');
            const initialDate = this.getInitialDate(this.options.dateInput);
            if (initialDate) {
                this.refreshDisplay(initialDate);
            }
            this.input.daterangepicker({
                autoUpdateInput: false,
                showDropdowns: true,
                buttonClasses: ['btn', 'btn-xs'],
                applyButtonClasses: 'btn-primary btn-delphi-no-chevron',
                cancelButtonClasses: 'btn-default',
                startDate: initialDate || moment(),
                endDate: initialDate || moment(),
                locale: this.locale,
                singleDatePicker: true
            }, (start, end) => this.refreshDisplay(start));
            this.input.on('apply.daterangepicker', (_e, picker) => this.onDateChange(picker));
            // allow "clear" button in any
            this.clearButton.click(() => this.clear());
            this.updateClearButton();
        }
        getDate() {
            return this.options.dateInput.val();
        }
        hasValue() {
            return this.getDate();
        }
        getInitialDate(input) {
            // daterangepicker *really* needs all input dates to be formatted NOT in display format, NOT in output format, NOT
            const value = moment(input.val(), SingleDatePicker.InputDateFormat);
            return value.isValid() ? value : null;
        }
        refreshDisplay(date) {
            this.input.val(date.format(SingleDatePicker.DisplayDateFormat));
            this.updateClearButton();
        }
        clear() {
            this.input.val('');
            this.options.dateInput.val('');
            if (this.options.onClear) {
                this.options.onClear();
            }
            this.updateClearButton();
        }
        onDateChange(picker) {
            this.refreshDisplay(picker.startDate);
            this.options.dateInput.val(picker.startDate.format(SingleDatePicker.InputDateFormat));
            if (this.options.onApply) {
                this.options.onApply();
            }
            this.updateClearButton();
        }
        updateClearButton() {
            this.clearButton.toggleClass('hidden', !this.hasValue());
        }
    }
    SingleDatePicker.DisplayDateFormat = 'YYYY-MM-DD';
    SingleDatePicker.InputDateFormat = 'YYYY-MM-DDTHH:mm:ss';
    SingleDatePicker.LocaleFr = {
        format: "DD/MM/YYYY",
        separator: " - ",
        applyLabel: "Appliquer",
        cancelLabel: "Annuler",
        fromLabel: "Du",
        toLabel: "Au",
        customRangeLabel: "Personnalisé",
        daysOfWeek: [
            "Di",
            "Lu",
            "Ma",
            "Me",
            "Je",
            "Ve",
            "Sa"
        ],
        monthNames: [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre"
        ],
        firstDay: 1
    };
    SingleDatePicker.LocaleEn = {
        format: "MM/DD/YYYY",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        fromLabel: "From",
        toLabel: "To",
        customRangeLabel: "Custom",
        weekLabel: "W",
        daysOfWeek: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        firstDay: 1
    };
    Dlrt.SingleDatePicker = SingleDatePicker;
})(Dlrt || (Dlrt = {}));
$.fn.makeSingleDatePicker = function (options) {
    return new Dlrt.SingleDatePicker(this, options);
};

//# sourceMappingURL=SingleDatePicker.js.map
